import React from "react";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {NodeType} from "../../../../../model/ModelData";
import {fieldSx} from "../editMenuStyles";
import {SubSectionHeader} from "../components/EditMenuSection";

export const FlowSettings = ({node, onUpdate, project, onChangeData}) => {
    const flowStartNodes = project?.flows?.map(f => {
        const startNode = {...f?.nodes?.find(n => n?.type === NodeType.START)};
        startNode.flow = f;
        return startNode;
    });

    return (
        <>
            <SubSectionHeader title="Flow"/>
            <FormControl size="small" fullWidth sx={fieldSx}>
                <InputLabel id="start-flow-select-label">Flow</InputLabel>
                <Select
                    labelId="start-flow-select-label"
                    value={node?.data?.flow_id || ""}
                    label="Flow"
                    onChange={(e) => onChangeData("flow_id", e.target.value)}
                    onBlur={() => onUpdate(node)}
                >
                    <MenuItem value=""><em>None</em></MenuItem>
                    {flowStartNodes?.map(startNode => (
                        <MenuItem key={startNode?.id} value={startNode?.id}>{startNode?.flow?.name}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
};
